import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from 'components/PageWrapper';
import ResourceForm from '../components/ResourceForm';
import {RESOURCE_CONSTRAINS} from 'constants/adminPupups';

const resourceUrl = '/api/v1/resourses/';

@inject('resourcesStore')
@inject('alertStore')
@observer
class EditResource extends PureComponent {
  componentDidMount() {
    const {match, resourcesStore: {setResource}} = this.props;
    const id = match.params.id;

    if(id) {
      new HttpClient().get(`${resourceUrl}${id}`).then(data => {
        const resourse = {
          ...data.body.data.resourse,
          file: {
            file_url: data.body.data.resourse.file_url
          }
        };

        setResource(resourse);
      }).catch(() => {
        this.props.alertStore.success('Something went wrong');
      });
    }
  }

  handleChange = e => {
    const {resourcesStore} = this.props;

    if (e.target.name === 'file') {
      resourcesStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      resourcesStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  validationProcess = resource => {
    let errors = validate(resource, RESOURCE_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {resourcesStore, match} = this.props;
    const id = match.params.id;
    const resource = _.assign({}, resourcesStore.resource);
    const errors = this.validationProcess(resource);

    resourcesStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', resource.title);
    if (resource.file.name)
      formData.append('file', resource.file, resource.file.name);

    new HttpClient().multipart(`${resourceUrl}${id}`, formData, 'PUT').then(data => {
      resourcesStore.saveResource(data.body.data.resourse);
      this.props.alertStore.success('You successfully edited OSCE');
      this.props.history.push('/resources');
      
    }).catch(() => {
      this.props.alertStore.success('Something went wrong');
    });
  };

  render() {
    return (
      <PageWrapper>
        <ResourceForm submit={this.submit} />
      </PageWrapper>
    );
  }
}

export default EditResource;



// WEBPACK FOOTER //
// ./src/modules/resources/containers/EditResource.js